import { render, staticRenderFns } from "./studentsBillMapping.vue?vue&type=template&id=caf17c30&scoped=true"
import script from "./studentsBillMapping.vue?vue&type=script&lang=js"
export * from "./studentsBillMapping.vue?vue&type=script&lang=js"
import style0 from "./studentsBillMapping.vue?vue&type=style&index=0&id=caf17c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf17c30",
  null
  
)

export default component.exports